<template>
  <div v-if="!isSplash()" class="mdl-cell--hide-desktop mdl-cell--hide-tablet mdl-layout__drawer">
    <router-link v-if="!user" to="/login" class="adv-sign-in-button adv-signed-out-only mdl-button mdl-js-button mdl-js-ripple-effect">
      <i class="material-icons">account_circle</i> Sign in</router-link>
    <div  v-if="user" class="adv-signed-in-user-container mdl-color--deep-orange adv-signed-in-only">
      <a class="adv-usernamelink">
        <div class="adv-avatar" :style="getUserAvatar()"></div>
        <div class="adv-username mdl-color-text--white">{{user && (user.displayName || user.email)}}</div>
      </a>
    </div>
    <nav class="mdl-navigation">
      <div class="nav-separator-title">Play</div>
      <router-link class="mdl-navigation__link" to="/"><i class="material-icons">gamepad</i> Adventures</router-link>
      <router-link class="mdl-navigation__link" to="/recent" v-if="user"><i class="material-icons">history</i> Recently Played</router-link>
      <div class="nav-separator-title" v-if="user">Create</div>
      <router-link class="mdl-navigation__link" to="/editor" v-if="user"><i class="material-icons">create</i> Adventure Editor</router-link>
      <router-link class="mdl-navigation__link" to="/documentation" v-if="user" ><i class="material-icons">local_library</i> Documentation</router-link>
      <div class="nav-separator-title" v-if="user">Account</div>
      <button style="border: none;" class="adv-sign-out mdl-navigation__link" v-if="user" @click="logOut"><i class="material-icons">exit_to_app</i> Sign Out</button>
    </nav>
  </div>
</template>
<script>

export default{
  data: () => ({
    isCreateMode(){
      return this.$route.path.startsWith("/editor") || this.$route.path.startsWith("/documentation");
    },
    isSplash(){
      var isSplash = this.$route.path === "/login";
      return isSplash;
    },
    getUserAvatar(){
      if(window.firebase.auth().currentUser) return 'background-image: url("' + (window.firebase.auth().currentUser.photoURL) + '")';
      return 'background-image: url("/images/silhouette.jpg")';
    },
    user: window.firebase.auth().currentUser
  }),
  created() {
    window.firebase.auth().onAuthStateChanged((user) => {
      this.user = user;
    });
  },
  methods: {    
    logOut() { 
      window.firebase.auth().signOut();
    }
  }
}

</script>
<style>

.mdl-layout__drawer .adv-sign-in-button{
  color: white;
  background-color: #FF5722;
  height: 54px;
  text-align: left;
  margin: 0;
  padding: 10px;
}

.mdl-layout__drawer .mdl-navigation{
  padding-top: 0px;
}

.mdl-layout__drawer{
  background-color: #37474F;
  text-align: left;
}

.mdl-layout__drawer router-link, .mdl-layout__drawer a{
  text-decoration: none;
}

.mdl-layout__drawer .mdl-navigation__link{
  background-color: white;
  text-decoration: none;
  cursor: pointer;
  text-align: left;
}

.mdl-layout__drawer .adv-signed-in-user-container{
  height: 70px;
} 
</style>



// WEBPACK FOOTER //
// SectionDrawerMenu.vue?1b820d03